"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientMedication_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MedicationType_1 = require("./MedicationType");
var PatientMedicationVersion_1 = require("./PatientMedicationVersion");
var PatientMedication_Factory = /** @class */ (function () {
    function PatientMedication_Factory() {
    }
    PatientMedication_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            MedicationType: MedicationType_1.MedicationType_Factory.CreateIncoming(model.MedicationType),
            MedicationTypeId: model.MedicationTypeId,
            PatientId: model.PatientId,
            PatientMedicationVersions: model.PatientMedicationVersions && model.PatientMedicationVersions.map(function (i) { return PatientMedicationVersion_1.PatientMedicationVersion_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    PatientMedication_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            MedicationType: MedicationType_1.MedicationType_Factory.CreateOutgoing(model.MedicationType),
            MedicationTypeId: model.MedicationTypeId,
            PatientId: model.PatientId,
            PatientMedicationVersions: model.PatientMedicationVersions && model.PatientMedicationVersions.map(function (i) { return PatientMedicationVersion_1.PatientMedicationVersion_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return PatientMedication_Factory;
}());
exports.PatientMedication_Factory = PatientMedication_Factory;
